/** Mobile shell routes. Same set App.vue uses for the phone column. */
const MOBILE_SHELL_PATHS = [
  '/mnotes',
  '/mdocs',
  '/mhome',
  '/ichat',
  '/mtenantsearch',
  '/mworkorders',
  '/msms',
  '/mvoice',
  '/lockcodes',
  '/appliances',
  '/quickemail',
  '/mproperties',
  '/collector',
  '/survey',
  '/calendar',
  '/workorder-schedule',
  '/rent-me',
];

/** Home tile that leaves the phone column. Still part of the /mhome flow. */
const EXTRA_NETWORK_BANNER_PATHS = ['/quicklook'];

const NETWORK_CHECK_MS = 3000;
const NETWORK_OUTAGE_MS = 12000;
const NETWORK_HEALTHY_MS = 20000;
const NETWORK_BANNER_TEXT = 'network connection is not reliable.';

function isMobileShellPath(path) {
  return MOBILE_SHELL_PATHS.includes(path);
}

/**
 * Phone screens reached from /mhome, plus any route on a phone.
 * Desktop /main stays quiet.
 */
function showsNetworkBannerOnRoute(path, mobileDevice) {
  if (isMobileShellPath(path) || EXTRA_NETWORK_BANNER_PATHS.includes(path)) {
    return true;
  }
  return !!mobileDevice && !!path;
}

/** True when the browser reports a network. Missing navigator counts as up. */
function readNavigatorOnline(nav) {
  const target =
    nav === undefined
      ? typeof navigator !== 'undefined'
        ? navigator
        : null
      : nav;
  if (!target || typeof target.onLine !== 'boolean') return true;
  return target.onLine;
}

function emptyNetworkBannerState() {
  return { offlineSince: null, onlineSince: null, visible: false };
}

/**
 * Offline must last NETWORK_OUTAGE_MS before the banner shows.
 * Healthy connectivity must last NETWORK_HEALTHY_MS before it hides.
 * A flip either way starts that clock over.
 */
function stepNetworkBanner(state, online, now) {
  const prev = state || emptyNetworkBannerState();
  const at = Number(now) || 0;
  if (!online) {
    const offlineSince = prev.offlineSince == null ? at : prev.offlineSince;
    return {
      offlineSince,
      onlineSince: null,
      visible: prev.visible || at - offlineSince >= NETWORK_OUTAGE_MS,
    };
  }
  if (!prev.visible) {
    return emptyNetworkBannerState();
  }
  const onlineSince = prev.onlineSince == null ? at : prev.onlineSince;
  const visible = at - onlineSince < NETWORK_HEALTHY_MS;
  return {
    offlineSince: null,
    onlineSince: visible ? onlineSince : null,
    visible,
  };
}

module.exports = {
  MOBILE_SHELL_PATHS,
  NETWORK_CHECK_MS,
  NETWORK_OUTAGE_MS,
  NETWORK_HEALTHY_MS,
  NETWORK_BANNER_TEXT,
  isMobileShellPath,
  showsNetworkBannerOnRoute,
  readNavigatorOnline,
  emptyNetworkBannerState,
  stepNetworkBanner,
};
